export const PROCEED_EVENT_NAME = 'proceed'
export const LOAD_EVENT_NAME = 'load'
export const MAX_DEPARTURE_DAY_WITHOUT_TODAY = 89
export const MAX_DEPARTURE_DAY_WITHOUT_TODAY_OUTBOUND = 179
export const MAX_DEPARTURE_DAY_WITHOUT_TODAY_USA = 59
export const MAX_RETURN_DAY = 90
export const INBOUND_MULTI_TRIP_RETURN_DAY = 180
